import React from 'react';
import { motion } from 'framer-motion';

export default function QuestionStep({ step, currentAnswer, onAnswer }) {
  return (
    <div className="w-full max-w-xl mx-auto flex flex-col justify-center min-h-[60vh]">
      <motion.h2 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-10 text-center leading-tight tracking-tight"
      >
        {step.question}
      </motion.h2>

      <div className="space-y-4">
        {step.options.map((option, index) => (
          <motion.button
            key={index}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => onAnswer(step.id, option)}
            className={`w-full text-left p-5 md:p-6 rounded-2xl border transition-all duration-300 
              ${currentAnswer === option 
                ? 'bg-white border-amber-500 shadow-lg shadow-amber-500/10 text-amber-600 scale-[1.02]' 
                : 'bg-white/50 border-zinc-200 text-zinc-700 hover:bg-white hover:border-zinc-300 hover:shadow-md'
              }
            `}
          >
            <div className="flex items-center">
              <div className={`w-5 h-5 rounded-full border flex items-center justify-center mr-4 transition-all duration-300
                ${currentAnswer === option ? 'border-amber-500 bg-amber-500' : 'border-zinc-300 bg-transparent'}
              `}>
                {currentAnswer === option && (
                  <div className="w-1.5 h-1.5 rounded-full bg-white" />
                )}
              </div>
              <span className="text-lg font-medium">{option}</span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}